export default "__VITE_ASSET__DPuJLsrP__"